import { HTMLAttributes } from "react";
import { useFeatures } from "./useFeatures";

interface FeatureProps extends HTMLAttributes<HTMLDivElement> {
    name?: string | string[]
}

export const Feature: React.FC<FeatureProps> = ({ name, children }) => {
    const canShow = useFeatures(name || []);
  
    if (!children) return null;
    if (!canShow) return null;
  
    return (
      <>
        {children}
      </>
    );
  };
